module.exports = __webpack_public_path__ + "static/02-c0cda20908a999ee12d4147fd483b4b4.jpg";